(function (ns) {
    'use strict';

    /*
     * Utils
     */
    var numbersOnly = function (s) {
        return s.toString().replace(/\D/g, '');
    };

    var goTime = {

        getAMPM: function (hour) {
            return hour >= 12 ? 'pm' : 'am';
        },

        formatHour: function (hour) {
            return hour > 12 ? hour - 12 : hour;
        },

        formatMinutes: function (minutes) {
            var mins = minutes.toString();
            if (mins.length < 2) {
                mins = '0' + mins;
            }
            return mins;
        },

        formatWeekday: function (dateTime) {
            var days = [];
            days[0] = 'Sun';
            days[1] = 'Mon';
            days[2] = 'Tue';
            days[3] = 'Wed';
            days[4] = 'Thu';
            days[5] = 'Fri';
            days[6] = 'Sat';

            return days[dateTime.getDay()];
        },

        formatMonth: function (dateTime) {
            var months = [];
            months[0] = 'Jan';
            months[1] = 'Feb';
            months[2] = 'Mar';
            months[3] = 'Apr';
            months[4] = 'May';
            months[5] = 'Jun';
            months[6] = 'Jul';
            months[7] = 'Aug';
            months[8] = 'Sep';
            months[9] = 'Oct';
            months[10] = 'Nov';
            months[11] = 'Dec';
            return months[dateTime.getMonth()];
        },

        formatDate: function (dateTime) {
            if (typeof dateTime === 'undefined') {
                return;
            }

            if (typeof dateTime !== 'object'
                && dateTime.toString().match(/[TZ]/gi).length === 2) {
                dateTime = new Date(Date.parse(dateTime));
            }

            var html = goTime.formatWeekday(dateTime)
                + ' '
                + dateTime.getDate()
                + ' '
                + goTime.formatMonth(dateTime)
                + ' '
                + dateTime.getFullYear();

            return html;
        },

        formatSession: function (startTime, endTime) {
            var fromHour = this.formatHour(startTime.getHours());
            var fromMin = this.formatMinutes(startTime.getMinutes());
            var fromAmPm = this.getAMPM(startTime.getHours());

            var toHour = this.formatHour(endTime.getHours());
            var toMin = this.formatMinutes(endTime.getMinutes());
            var toAmPm = this.getAMPM(endTime.getHours());

            var html = fromHour
                + ':'
                + fromMin
                + fromAmPm
                + ' - '
                + toHour
                + ':'
                + toMin
                + toAmPm;

            return html;
        },

        createDate: function (dateTime) {
            var dateTimes = dateTime.trim().split(' ');

            if (!dateTimes[0]) {
                return;
            }

            var dates = dateTimes[0].split('-');

            if (dateTimes[1]) {
                var times = dateTimes[1].split(':');
                return new Date(
                    numbersOnly(dates[0]),
                    numbersOnly(dates[1]-1),
                    numbersOnly(dates[2]),
                    numbersOnly(times[0] || '0'),
                    numbersOnly(times[1] || '0'),
                    numbersOnly(times[2] || '0')
                );
            }
            return new Date(
                numbersOnly(dates[0]),
                numbersOnly(dates[1]-1),
                numbersOnly(dates[2])
            );
        }

    };

    /*
     * Event Sessions
     */
    ns.Ateed.Components.EventSessions = function () {

        /*
         * Main
         */
        var main = function () {
            updateHTML();

            var $sessions = $('.field--name-field-ev-sessions')
                .contents()
                .filter(function () {
                    return this.nodeType === 3 && this.textContent.trim() !== '';
                });

            if ($sessions.length === 0) {
                return;
            }

            var sessions = sanitizeSessions($sessions[0].data);

            if (sessions.length === 0) {
                return;
            }

            sessions = mergeDates(sessions);
            createSessionHTML(sessions);
            createVueModel();
            //updateHTML();
        };

        var sanitizeSessions = function (data) {
            var list = data.split(',');
            var formatted = list.map(function (item) {
                var dates = item.split(' - ');

                var startDate = goTime.createDate(dates[0]);
                var endDate = goTime.createDate(dates[1]);

                if (!startDate || !endDate) {
                    return;
                }

                return {
                    date: goTime.formatDate(startDate),
                    time: goTime.formatSession(startDate, endDate)
                };
            });
            return formatted;
        };

        var mergeDates = function (list) {

            var set = [];
            var isUnique = true;
            var listItem;
            var setItem;

            // The old double loop
            for (var i = 0; i < list.length; i++) {

                isUnique = true;
                listItem = list[i];

                for (var j = 0; j < set.length; j++) {

                    setItem = set[j];

                    if (listItem.date === setItem.date) {

                        setItem.time.push(listItem.time);
                        isUnique = false;
                    }
                }

                if (isUnique) {
                    set.push({
                        date: listItem.date,
                        time: [listItem.time]
                    });
                }
            }
            return set;
        };

        var convertToHTMLList = function (items) {
            var html = '';
            items.forEach(function (item) {
                html += item.date
                    + '<br />';
                if (item.time) {
                    item.time.forEach(function (time) {
                        html += '<span class="small" style="padding-left:10px;">'
                            + time
                            + '</span>'
                            + '<br />';
                    });
                }
            });
            return html;
        };

        var shortSessionsHTML = function (set) {
            var html = '<div class="sessions-list expandable">'
                + '<div>'
                + set
                + '</div>'
                + '</div>';
            return html;
        };

        var longSessionsHTML = function (firstSet, middleSet, lastSet) {
            var html = '<div class="sessions-list expandable">'
                + '<div>'
                + firstSet
                + '</div>'
                + '<span v-if="!surplusDatesVisible" class="ateed-indicator ateed-dots"></span>'
                + '<span v-if="surplusDatesVisible">'
                + middleSet
                + '</span>'
                + '<div>'
                + lastSet
                + '</div>'
                + '<a class="clickable" v-on:click="toggleSurplusDates">'
                + '<span>{{surplusDatesExpanderText}} </span>'
                + '<span v-bind:class="surplusDatesArrow" class="ateed-indicator"></span>'
                + '</a>'
                + '</div>';
            return html;
        };

        var createSessionHTML = function (sessions) {

            var sessionsHTMLDocument = '';
            var $elSessions = $('.ateed-article-aside .field--name-field-ev-date-starts');

            if (sessions.length > 4) {

                var firstItems = sessions.slice(0, 1);
                var lastItems = sessions.slice(-1);
                var middleItems = sessions.slice(1, -1);
                var firstItemsHTML = convertToHTMLList(firstItems);
                var lastItemsHTML = convertToHTMLList(lastItems);
                var middleItemsHTML = convertToHTMLList(middleItems);

                sessionsHTMLDocument = longSessionsHTML(firstItemsHTML, middleItemsHTML, lastItemsHTML);
                $elSessions.after(sessionsHTMLDocument);
            }
            else {
                var itemsHTML = convertToHTMLList(sessions);

                sessionsHTMLDocument = shortSessionsHTML(itemsHTML);
                $elSessions.after(sessionsHTMLDocument);
            }
        };

        var createVueModel = function () {
            var viewModel = new Vue({ // eslint-disable-line no-unused-vars
                el: $('.sessions-list.expandable')[0],
                data: {
                    surplusDatesVisible: false
                },
                computed: {
                    surplusDatesExpanderText: function () {
                        return !this.surplusDatesVisible ? 'show more dates' : 'show less dates';
                    },
                    surplusDatesArrow: function () {
                        return !this.surplusDatesVisible ? 'ateed-arrow-down-xs-interactive' : 'ateed-arrow-up-xs-interactive';
                    }
                },
                methods: {
                    toggleSurplusDates: function () {
                        this.surplusDatesVisible = !this.surplusDatesVisible;
                    }
                }
            });
        };

        var updateHTML = function () {

            $('.block-fieldblock .field--name-field-ev-date-starts').remove();
            $('.block-fieldblock .field--name-field-ev-date-ends').remove();

            $('.ateed-article-aside .field--name-field-ev-date-starts').remove();
            $('.ateed-article-aside .field--name-field-ev-sessions').remove();
            $('.ateed-article-aside .field--name-field-ev-date-ends').remove();

            // add powered by eventfinda image
            // eventfinda and zomato logo converted into template.
            //$('.field--name-field-ev-eventfinda-id').replaceWith('<div class="ateed-eventfinda">Powered by <a class="eventfinda_logo" href="https://www.eventfinda.co.nz/whatson/events/auckland" target="_blank"><picture><source src="/themes/custom/ba/ateed/dist/resources/images/eventfinda.png" /><source src="/themes/custom/ba/ateed/dist/resources/images/eventfinda@2x.png" media="only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)" /><img src="/themes/custom/ba/ateed/dist/resources/images/eventfinda.png"></picture></a></div>');
            //$('.field--name-field-ev-eventfinda-id').replaceWith('<div class="ateed-eventfinda">Powered by <a class="eventfinda_logo" href="https://www.eventfinda.co.nz/whatson/events/auckland" target="_blank"><div class="eventfinda_logo_placeholder"></div></a></div>');
            // add powered by zomato image
            //$('.field--name-field-lb-zomato-id').replaceWith('<div class="ateed-zomato"></div>');


            if ($('.field--name-field-ev-tags, .field--name-field-lb-tags').length > 0) {
                $('.field--name-field-ev-tags, .field--name-field-lb-tags')
                    .html($('.field--name-field-ev-tags, .field--name-field-lb-tags')
                        .html()
                        .split(',')
                        .map(function (e) {
                            return '<div class="field--item"><a>' + e.trim() + '</a></div>';
                        })
                    );
            }
        };

        /*
         * Instantiate Main
         */
        main();
    };

})(window);

// *
(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.venueToggler = {
    switcher: 0,
    toggleVenues: function(e) {
      //console.log('venueToggler toggleVenues', Drupal.behaviors.venueToggler.switcher);
      var rows = document.querySelectorAll(".hide-row");
      if (Drupal.behaviors.venueToggler.switcher == 0) {
        for (var i in rows) {
          var row = rows.item(i);
          row.style.display = 'table-row';
          row.classList.remove('hidden');
        }
        Drupal.behaviors.venueToggler.switcher = 1;
        document.getElementById("ateed-venue-btn").innerHTML = "+ Close";
      } else {
        for (var i in rows) {
          var row = rows.item(i);
          row.style.display = 'none';
        }
        Drupal.behaviors.venueToggler.switcher = 0;
        document.getElementById("ateed-venue-btn").innerHTML = "+ See more";
      }
    },
    attach: function(context, settings) {
      //console.log('venueToggler attach');
//      $("#ateed-venue-btn").once('venue-toggler').on('click', Drupal.behaviors.venueToggler.toggleVenues);
      $(once('venue-toggler', '#ateed-venue-btn')).on('click', Drupal.behaviors.venueToggler.toggleVenues);

    }
  }
})(jQuery, Drupal, drupalSettings);
// */

(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.tableOverflow = {
    checkOverflow: function(el) {
//      console.log('checkOverflow', el)
      var curOverflow = el.style.overflowX;
//      console.log('curOverflow', curOverflow)
      if ( !curOverflow || curOverflow === "visible" )
        el.style.overflowX = "hidden";

      var isOverflowing = el.clientWidth < el.scrollWidth
        || el.clientHeight < el.scrollHeight;

      el.style.overflowX = curOverflow;

      return isOverflowing;
    },
    checkTables: function(el) {
//      $('body.section--meet .article-table, .page-node-type-local-business  .article-table').each(function(){
       document.querySelectorAll('body.section--meet .article-table table, .page-node-type-local-business  .article-table table').forEach(function(elem) {
//         console.log(elem)

//        var $elem = $(this);
        var isOverflowing = Drupal.behaviors.tableOverflow.checkOverflow(elem);
//        console.log('checkTables', elem, isOverflowing)

        elem.classList.toggle('is-overflowing', isOverflowing);
      });
    },
    attach: function (context, settings) {
//      console.log('tableOverflow attach')
//      $(window).once('table-overflow').on('resize', function() {
      once('table-overflow', 'html', context).forEach(function(el) {
//        console.log('once', el)

//        $(el).on('resize', function() {
        window.addEventListener('resize', function(event) {
//          console.log('resize');
          Drupal.behaviors.tableOverflow.checkTables();
        })
//.one('load',  function() {
        window.addEventListener('load', function(event) {
//          console.log('load');
          Drupal.behaviors.tableOverflow.checkTables()
        })
      })
    }
  }
})(jQuery, Drupal, drupalSettings);

(function () {
    'use strict';

    window.Ateed.Components.ArticleAside = function () {

        // create event listeners for contact-form enquiry button
        $('a.contact-form').on('click', function () {

            $('#drupal-modal').on('shown.bs.modal', function () {

                $('.modal-footer').css({
                    'max-width': '640px',
                    'margin-left': 'auto',
                    'margin-right': 'auto',
                    'padding': '0px',
                    'border-top': 'none'
                });

                $('.modal-header').css({
                    'max-width': '640px',
                    'margin-left': 'auto',
                    'margin-right': 'auto',
                    'padding-left': '0px',
                    'padding-top': '15px',
                    'padding-bottom': '15px'
                });

                $('.modal-footer > button, .modal-footer > .modal-buttons > button').css({
                    float: 'left'
                });

            });

        });

        // create booking link button
        var bookingLink = $('.field--name-field-ev-booking-website');

        if (bookingLink.length > 0) {

            $('.field--name-field-ev-booking-website a')
                .addClass('ateed-article-aside-cta btn btn-lg btn-primary')
                .text('Get Tickets');
            bookingLink.replaceWith(bookingLink.html());
        }

        $('.ateed-article-aside-cta.btn.btn-lg.btn-primary.bookit').click(function (e) {

            e.preventDefault();
            $('#myFormModal')
                .modal('show')
                .find('.modal-body')
                .css({height: '600px'});
            $('#myFormModal')
                .modal('show')
                .find('.modal-body')
                .html('<iframe src="' + $(this).attr('data-iframe-url') + '" frameborder="0" style="width: 100%; height: 100%; border: none;"></iframe>');
        });

        // re-order block component date information together
        var $from = $('.block-fieldblock .field--name-field-ev-date-starts').html();
        var $to = $('.block-fieldblock .field--name-field-ev-date-ends').html();

        if ($from === $to) {
            $('.block-fieldblock .field--name-field-ev-date-starts').after(
                '<div class="session-date-range">' +
                '<span>' + $('.block-fieldblock .field--name-field-ev-date-starts').html() + '</span>'
            );
        }
        else {
            $('.block-fieldblock .field--name-field-ev-date-starts').after(
                '<div class="session-date-range">' +
                '<span>' + $('.block-fieldblock .field--name-field-ev-date-starts').html() + '</span>' +
                ' to ' +
                '<span>' + $('.block-fieldblock .field--name-field-ev-date-ends').html() + '</span>' +
                '</div>'
            );
        }

    };

})();
